export default __webpack_public_path__ + "static/journalists-b32e048acfef0dad0096dd321cbe7a42.png";